import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  contactWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderColor: colors.newUI.therapist.bgBlue10,
  },
  emailWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  emailText: {
    fontWeight: 600,
    paddingLeft: 12,
  },
  emailButtonSmall: {
    width: '100%',
    justifyContent: 'center',
    marginTop: 16,
  },
  phoneWrapper: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 16,
    flexWrap: 'wrap',
  },
  phoneTextAndIconWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flex: 1,
    paddingRight: 12,
  },
  phoneTextWrapper: {
    flexDirection: 'column',
    paddingLeft: 12,
    flex: 1,
  },
  phoneNumberWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 8,
    flexWrap: 'wrap',
  },
});
